import React from 'react';
import {
    Table,
    Button,
    Space,
    Card,
    Switch,
    Tooltip,
} from 'antd'
import { UserSegmentsData } from '@a4b/api/src/modules/Monetisation/Puja/types'
import type { TablePaginationConfig } from 'antd/es/table';
import { PlusSquareOutlined } from '@ant-design/icons';
import styled from 'styled-components';

interface Props {
    userSegmentList: UserSegmentsData | undefined
    paginationParams: TablePaginationConfig
    handleTableChange: (paginationParams: TablePaginationConfig) => void
    onCreateNew: () => void
    onStatusChange: (item: any) => void
    triggerEdit: (data: any) => void
    isLoading: boolean
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex-grow: 1;
  }
`
const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`

const UserSegmentList: React.FC<Props> = ({ userSegmentList, paginationParams, handleTableChange, onCreateNew, onStatusChange, triggerEdit, isLoading }) => {

    const dataSource = userSegmentList?.user_segments

    const formatDate = (text: string) => {
        const date = new Date(text);
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
        const year = date.getUTCFullYear().toString();
        return `${day}-${month}-${year}`
    }

    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            width: 200,
            ellipsis: {
                showTitle: false,
            },
            render: (id: string) => (
                <Tooltip placement="topLeft" title={id}>
                    {id}
                </Tooltip>),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            ellipsis: {
                showTitle: false,
            },
            render: (id: string) => (
                <Tooltip placement="topLeft" title={id}>
                    {id}
                </Tooltip>),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'SKU Order',
            dataIndex: 'sku_order',
            key: 'sku_order',
        },
        {
            title: 'No of Users Ids',
            dataIndex: 'user_ids',
            key: 'user_ids',
            render: (text: string, record: any) => {
                return <p>{Object.keys(record?.user_ids).length}</p>
            }
        },
        {
            title: 'Position',
            dataIndex: 'position',
            key: 'position',
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text: string) => {
                if (text) {
                    return formatDate(text)
                }
                return "-"
            }
        },
        {
            title: 'Service type',
            dataIndex: 'service_type',
            key: 'service_type',
            render: (text: string) => {
                if (text) {
                    return text
                }
                return "-"
            }
        },
        {
            title: 'Active',
            dataIndex: 'active',
            key: 'active',
            render: (text: string, record: any) => {
                return <Switch
                    checked={record.active}
                    onChange={() => onStatusChange(record)}
                />
            }
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            render: (text: string, record: any) => {
                return <Button onClick={() => { triggerEdit(record) }} type='link' color='cyan' style={{ cursor: 'pointer' }}>Edit</Button>
            }
        },
    ];

    return (

        <Container style={{ width: '100%' }}>
            <Space direction={'vertical'} style={{ width: '100%' }}></Space>
            <BodyContainer>
                <Button type='text' onClick={onCreateNew}>
                    <PlusSquareOutlined /> Create User Segment
                </Button>

                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={paginationParams}
                    onChange={handleTableChange}
                    loading={isLoading}
                />
            </BodyContainer>
        </Container>
    )

}

export default UserSegmentList
